const COMPANY_NAME = '徐州弘毅科技发展有限公司';
const SYSTEM_NAME = '冲击矿压风险智能判识与多参量监测预警云平台';
const SYSTEM_PULL_INTERVAL = 1000 * 60; // 数据轮询秒数
const QUAKE_SIZE_MIN = 5;// 2
const QUAKE_SIZE_STEP = 1.5;
const QUAKE_SIZE_MAX = 10;
const STRAIN_ENERGY_STEP = 20;//冲击变形能步长
const STRAIN_ENERGY_EXPANSION = 100;//冲击变形能扩充米数
const FRONT_SIZE = 15; //报表文字
const SHOW_HOLE_RANGE_METRE = 10;//显示一定范围内的钻孔数，用于显示主页推进度前方的钻孔信息
const LEVEL_NAME = [//10的次方显示 用于echarts 左侧Y轴数据
    "10" + String.fromCharCode(8304) + "J",
    "10" + String.fromCharCode(185) + "J",
    "10" + String.fromCharCode(178) + "J",
    "10" + String.fromCharCode(179) + "J",
    "10" + String.fromCharCode(8308) + "J",
    "10" + String.fromCharCode(8309) + "J",
    "10" + String.fromCharCode(8310) + "J",
    "10" + String.fromCharCode(8311) + "J",
    "10" + String.fromCharCode(8312) + "J",
    "10" + String.fromCharCode(8313) + "J"
];

const SELECT_LEVEL_NAME = [//选择下拉框
    {value:0,label:'全部'},
    {value:10,label:"10" + String.fromCharCode(185) + "J事件及以上"},
    {value:100,label:"10" + String.fromCharCode(178) + "J事件及以上"},
    {value:1000,label:"10" + String.fromCharCode(179) + "J事件及以上"},
    {value:10000,label:"10" + String.fromCharCode(8308) + "J事件及以上"},
    {value:100000,label:"10" + String.fromCharCode(8309) + "J事件及以上"}
];

const DIRECTION_LIST = [
    {num:0,angle:0,name:'北'},
    {num:1,angle:45,name:'东北'},
    {num:2,angle:90,name:'东'},
    {num:3,angle:135,name:'东南'},
    {num:4,angle:180,name:'南'},
    {num:5,angle:225,name:'西南'},
    {num:6,angle:270,name:'西'},
    {num:7,angle:315,name:'西北'},
];

const GREEN_COLOR = "#00B541";
const BLUE_COLOR = "#226CE2";
const YELLOW_COLOR = "#FF9604";
const RED_COLOR = "red";
const LETTER_LIST = ['A','B','C','D'];
const WORDS_LIST = ['无','弱','中','强'];

const QUAKE_LEVEL_COLOR_LIST = [GREEN_COLOR,BLUE_COLOR,YELLOW_COLOR,RED_COLOR];

export default{
    STRAIN_ENERGY_EXPANSION,
    COMPANY_NAME,
    SYSTEM_NAME,
    SYSTEM_PULL_INTERVAL,
    QUAKE_SIZE_MIN,
    QUAKE_SIZE_STEP,
    QUAKE_SIZE_MAX,
    STRAIN_ENERGY_STEP,
    LEVEL_NAME,
    SELECT_LEVEL_NAME,
    DIRECTION_LIST,
    GREEN_COLOR,
    BLUE_COLOR,
    YELLOW_COLOR,
    RED_COLOR,
    QUAKE_LEVEL_COLOR_LIST,
    LETTER_LIST,
    WORDS_LIST,
    FRONT_SIZE,
    SHOW_HOLE_RANGE_METRE,
}



// WEBPACK FOOTER //
// ./src/constants/system.constants.js